const STORAGE_KEY = 'lotus_casino_favorites_v1'
export const CASINO_FAVORITES_CHANGED_EVENT = 'lotus-casino-favorites-changed'

export type FavoriteCasinoGame = {
  gameId: string
  gameName: string
  imageUrl?: string
  provider?: string
  identifier?: string
  addedAt: number
}

function notify() {
  try {
    window.dispatchEvent(new CustomEvent(CASINO_FAVORITES_CHANGED_EVENT))
  } catch {
    /* ignore */
  }
}

function readAll(): FavoriteCasinoGame[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function writeAll(items: FavoriteCasinoGame[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  notify()
}

export function getCasinoFavorites(): FavoriteCasinoGame[] {
  return readAll()
}

export function isCasinoFavorite(gameId: string | number): boolean {
  const id = String(gameId)
  return readAll().some((f) => f.gameId === id)
}

export function toggleCasinoFavorite(game: {
  gameId?: string | number
  identifier?: string | number
  game_name?: string
  gameName?: string
  game_images?: string
  image_url?: string
  provider?: string
}): boolean {
  const gameId = String(game.gameId ?? game.identifier ?? '')
  if (!gameId) return false

  const all = readAll()
  const existing = all.findIndex((f) => f.gameId === gameId)
  if (existing >= 0) {
    all.splice(existing, 1)
    writeAll(all)
    return false
  }

  all.unshift({
    gameId,
    gameName: game.game_name || game.gameName || gameId,
    imageUrl: game.game_images || game.image_url || '',
    provider: game.provider,
    identifier: game.identifier ? String(game.identifier) : undefined,
    addedAt: Date.now(),
  })
  writeAll(all)
  return true
}

export function removeCasinoFavorite(gameId: string | number) {
  const id = String(gameId)
  writeAll(readAll().filter((f) => f.gameId !== id))
}
